// @format

import 'jquery-drawer'

declare global {
  interface JQuery {
    drawer(): JQuery
  }
}

export function initDrawer(): void {
  const $drawer = $('#task-drawer')
  if (!$drawer.length) return

  $drawer.drawer()

  $('#open-drawer').off('click').on('click', () => {
    $drawer.addClass('drawer-open')
    $('body').addClass('no-scroll')

    clearTaskForm()
    updateTaskDrawerButtons()
  })

  $drawer.find('.drawer-close').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
    $('body').removeClass('no-scroll')
  })

  $drawer.find('.drawer-overlay').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
    $('body').removeClass('no-scroll')
  })

  $(document).off('click', '.edit-task-button').on('click', '.edit-task-button', function (event) {
    event.stopPropagation();
    const taskData = {
      id: $(this).data('id'),
      subject: $(this).data('subject'),
      priority: $(this).data('priority'),
      type: $(this).data('type'),
      status: $(this).data('status'),
      assignedTo: $(this).data('assigned-to'),
      reminder: $(this).data('reminder'),
      dueDate: $(this).data('due-date'),
      dueTime: $(this).data('due-time'),
      notes: $(this).data('notes'),
    }

    populateTaskForm(taskData)
    updateTaskDrawerButtons(true)

    $drawer.addClass('drawer-open')
    $('body').addClass('no-scroll')
  })

  $('#create-task-btn').off('click').on('click', function (e) {
    e.preventDefault()

    const data = {
      customer_id: new URLSearchParams(window.location.search).get('id') || '',
      title: $('#task-title').val(),
      task_type: $('#task-type').val(),
      priority: $('#task-priority').val(),
      assigned_to: $('#task-assigned-to').val(),
      queue: $('#task-queue').val(),
      reminder: $('#reminder').val(),
      due_date: $('#due-date-options').val(),
      due_time: $('#due-time-options').val(),
      notes: $('#task-notes').summernote('code')
    }

    const $drawerNav = $('.drawer-nav')
    const $drawerOverlay = $('.drawer-overlay')

    $.ajax({
      url: '/customer_success/create_task',
      method: 'POST',
      data: data,
      beforeSend: function () {
        $drawerNav.css({ 'pointer-events': 'none', 'opacity': 0.9 })
        $drawerOverlay.css({ 'pointer-events': 'none' })

        if ($drawerNav.find('.ajax-loading-spinner').length === 0) {
          const spinner = $(`
            <div class="ajax-loading-spinner">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          `)

          $drawerNav.append(spinner)
        }
      },
      success: function (response) {
        location.reload()
      },
      error: function (xhr) {
        console.error('Failed to create task', xhr.responseText)
      },
      complete: function () {
        $drawerNav.css({ 'pointer-events': '', 'opacity': '' })
        $drawerOverlay.css({ 'pointer-events': '' })
        $drawerNav.find('.ajax-loading-spinner').remove()
      }
    })
  })

  $('#save-task-btn').off('click').on('click', function (e) {
    e.preventDefault()

    const data = {
      id: $('#task-id').val(),
      title: $('#task-title').val(),
      task_type: $('#task-type').val(),
      priority: $('#task-priority').val(),
      assigned_to: $('#task-assigned-to').val(),
      queue: $('#task-queue').val(),
      reminder: $('#reminder').val(),
      due_date: $('#due-date-options').val(),
      due_time: $('#due-time-options').val(),
      notes: $('#task-notes').summernote('code')
    }

    const $drawerNav = $('.drawer-nav')
    const $drawerOverlay = $('.drawer-overlay')

    $.ajax({
      url: '/customer_success/update_task',
      method: 'PATCH',
      data: data,
      beforeSend: function () {
        $drawerNav.css({ 'pointer-events': 'none', 'opacity': 0.9 })
        $drawerOverlay.css({ 'pointer-events': 'none' })

        if ($drawerNav.find('.ajax-loading-spinner').length === 0) {
          const spinner = $(`
            <div class="ajax-loading-spinner">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          `)

          $drawerNav.append(spinner)
        }
      },
      success: function (response) {
        location.reload()
      },
      error: function (xhr) {
        console.error('Failed to save task', xhr.responseText)
      },
      complete: function () {
        $drawerNav.css({ 'pointer-events': '', 'opacity': '' })
        $drawerOverlay.css({ 'pointer-events': '' })
        $drawerNav.find('.ajax-loading-spinner').remove()
      }
    })
  })

  $('#cancel-task-btn').off('click').on('click', () => {
    $drawer.removeClass('drawer-open')
  })

  $('#delete-task-btn').off('click').on('click', function () {
    const taskId = $(this).data('task-id')
    const customerId = $(this).data('customer-id')

    $('#delete-task-id').val(taskId)
    $('#delete-customer-id').val(customerId)

    $('#deleteTaskModal').modal('show')
  })

  initDueDate()
}

function clearTaskForm() {
  $('#task-title').val('')
  $('#task-type').val('TODO')
  $('#task-priority').val('NONE')
  $('#task-assigned-to').val('simon@intro.io')
  $('#task-queue').val('')
  $('#due-date').val('')
  $('#reminder').val('')
  $('#task-notes').summernote('code', '')
}

function populateTaskForm(data: any) {
  $('#task-id').val(data.id)
  $('#task-title').val(data.subject)
  $('#task-type').val(data.type || 'TODO')
  $('#task-priority').val(data.priority || 'NONE')
  $('#task-assigned-to').val(data.assignedTo || 'simon@intro.io')
  $('#task-queue').val(data.queue || '')
  $('#due-date-options').val(data.dueDate?.split('T')[0] || '')
  $('#due-time-options').val(data.dueTime?.split('T')[0] || '')
  $('#reminder').val(data.reminder || '')
  $('#task-notes').summernote('code', data.notes || '')
}

function updateTaskDrawerButtons(isEditMode = false) {
  if (isEditMode) {
    $('#create-task-btn').addClass('d-none')
    $('#save-task-btn, #cancel-task-btn, #delete-task-btn').removeClass('d-none')
    $('#delete-task-btn').attr('data-task-id', $('#task-id').val() as string)
  } else {
    $('#create-task-btn').removeClass('d-none')
    $('#save-task-btn, #cancel-task-btn, #delete-task-btn').addClass('d-none')
  }
}

function initDueDate() {
  const dateSelect = document.getElementById('due-date-options') as HTMLSelectElement
  if (!dateSelect) return

  const today = new Date()

  const options = [
    { label: "Today", date: today },
    { label: "Tomorrow", date: addDays(today, 1) },
    { label: "In 1 business day", date: addBusinessDays(today, 1) },
    { label: "In 2 business days", date: addBusinessDays(today, 2) },
    { label: "In 3 business days", date: addBusinessDays(today, 3) },
    { label: "In 1 week", date: addDays(today, 7) },
    { label: "In 2 weeks", date: addDays(today, 14) },
    { label: "In 1 month", date: addDays(today, 30) },
  ]

  options.forEach(option => {
    const formattedDate = option.date.toLocaleDateString(undefined, {
      weekday: 'long',
      month: 'short',
      day: 'numeric'
    })
    const opt = document.createElement('option')

    opt.value = option.date.toISOString().split('T')[0]
    opt.textContent = `${option.label} (${formattedDate})`

    dateSelect.appendChild(opt)
  })

  function addDays(date: Date, days: number): Date {
    const result = new Date(date)

    result.setDate(result.getDate() + days)

    return result
  }

  function addBusinessDays(date: Date, days: number): Date {
    const result = new Date(date)

    while (days > 0) {
      result.setDate(result.getDate() + 1)

      const day = result.getDay()

      if (day !== 0 && day !== 6) { days-- }
    }

    return result
  }

  const fixedDiv = document.querySelector<HTMLDivElement>('.body-drawer');

  if (fixedDiv) {
    fixedDiv.addEventListener('wheel', (e: WheelEvent) => {
      e.preventDefault();
      fixedDiv.scrollTop += e.deltaY; 
    });
  }
}
